import { Token } from 'config/types'
import Column from 'layout/Components/Column'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { filterTokenAmountSearch } from 'utils/token'
import { useFilterOptionsBySearch } from 'views/Payment/DesktopPayment/components/PaymentSelect/hooks'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { useAvailableDepositTokens, useFetchOptionsCurrencyBalance } from 'views/Payment/MobilePayment/hooks/useTokens'
import CurrencyRowItem from '../../../../PaymentTokenSelectModal/CurrencyRowItem'
import { useStoredSearchToken } from '../../../../PaymentTokenSelectModal/useStoredSearchToken'
import { EmptyCurrencyResponse, EmptyMessageEnum, PaymentAppSearch, PaymentLabel } from '../../../../styles'

const PAGE = PaymentPageEnums.Deposit

type TokenSelectProps = {
  selectedToken: Token
  onCurrencySelect: (token: Token) => void
}
const TokenSelect: React.FC<TokenSelectProps> = ({ selectedToken, onCurrencySelect }) => {
  const storedSearch = useStoredSearchToken(PAGE)
  const { t } = useTranslation()

  const { currenciesGroupSameCode, isValidAddress } = useAvailableDepositTokens({
    onCurrencySelect,
    selectedCurrency: selectedToken,
    hideHUSDToken: true,
    from: PAGE,
  })

  const { currencies, fetchBalance: fetchBalanceControl } = useFetchOptionsCurrencyBalance({
    curriencies: currenciesGroupSameCode,
    from: PAGE,
  })

  const { onChange, options, typedValue } = useFilterOptionsBySearch({
    options: currencies,
    filterFn: filterTokenAmountSearch,
  })

  const handleChangeToken = (token: Token) => {
    onCurrencySelect(token)
  }

  return (
    <Column gap="12px">
      <PaymentAppSearch autoFocus={false} placeholder={t('Search Coins')} onValueChanged={onChange} />

      <PaymentLabel bold>
        <Trans>List Coins</Trans>
      </PaymentLabel>

      <Column
        className="hide-scroll"
        gap="8px"
        overflowY="scroll"
        height={`calc(100% - ${storedSearch.tokens.length > 0 && !typedValue ? '275px' : '185px'})`}
      >
        {options.length > 0
          ? options.map((currency) => (
              <CurrencyRowItem
                hideNetwork
                selectedToken={selectedToken}
                currency={currency.token}
                amount={currency.amount}
                from={PAGE}
                fetchBalance={isValidAddress ? fetchBalanceControl : undefined}
                onSelect={() => {
                  storedSearch.record(currency.token.code, currency.token.address, currency.token.network, false)
                  handleChangeToken(currency.token)
                }}
              />
            ))
          : typedValue && <EmptyCurrencyResponse message={EmptyMessageEnum.Currency} />}
      </Column>
    </Column>
  )
}

export default TokenSelect
